import { addDays } from './piQuery.js';

export const PI_BASE_PATH = '/product-intelligence';

export const PI_VIEWS = [
  { key: 'overview', path: PI_BASE_PATH, label: 'Visão geral' },
  { key: 'assistant', path: PI_BASE_PATH + '/chat', label: 'Chat' },
  { key: 'engagement', path: PI_BASE_PATH + '/engajamento', label: 'Engajamento' },
  { key: 'features', path: PI_BASE_PATH + '/funcionalidades', label: 'Funcionalidades' },
  { key: 'areas', path: PI_BASE_PATH + '/areas', label: 'Áreas' },
  { key: 'activation', path: PI_BASE_PATH + '/ativacao', label: 'Ativação' },
  { key: 'retention', path: PI_BASE_PATH + '/retencao', label: 'Retenção' },
  { key: 'operations', path: PI_BASE_PATH + '/operacoes', label: 'Operações' },
  { key: 'companies', path: PI_BASE_PATH + '/empresas', label: 'Empresas' },
  { key: 'opportunities', path: PI_BASE_PATH + '/oportunidades', label: 'Oportunidades', revenue: true },
  { key: 'status', path: PI_BASE_PATH + '/status', label: 'Status e catálogo' },
];

export const KPI_LINKS = {
  dau: PI_BASE_PATH + '/engajamento',
  wau: PI_BASE_PATH + '/engajamento',
  mau: PI_BASE_PATH + '/engajamento',
  stickiness: PI_BASE_PATH + '/engajamento',
  activeCompanies: PI_BASE_PATH + '/empresas',
  activeSeatsRate: PI_BASE_PATH + '/engajamento',
  was: PI_BASE_PATH + '/engajamento',
  activation30d: PI_BASE_PATH + '/ativacao',
  retentionW4: PI_BASE_PATH + '/retencao',
  top10Concentration: PI_BASE_PATH + '/engajamento',
};

export const MENU_CACHE_KEY = 'pi:menu-visible';

export const MENU_CACHE_TTL_MS = 10 * 60 * 1000;

export const REVENUE_CACHE_KEY = 'pi:revenue-visible';

const segment = (value) => encodeURIComponent(String(value));

export const viewPath = (key) => {
  for (let i = 0; i < PI_VIEWS.length; i++) {
    if (PI_VIEWS[i].key === key) return PI_VIEWS[i].path;
  }
  return PI_BASE_PATH;
};

export const visibleViews = (views, revenueAllowed, current) => (Array.isArray(views) ? views : [])
  .filter((view) => !!view && (!view.revenue || revenueAllowed === true || view.key === current));

export const featureRoute = (featureType) => {
  if (featureType === null || featureType === undefined || featureType === '') return null;
  return PI_BASE_PATH + '/funcionalidades/' + segment(featureType);
};

export const companyRoute = (companyId, shardCode) => {
  if (!companyId || !shardCode) return null;
  return PI_BASE_PATH + '/empresas/' + segment(companyId) + '/' + segment(shardCode);
};

export const METRIC_PATH_SEPARATOR = '~';

export const metricPathSegment = (key) => (key === null || key === undefined ? '' : String(key)).replace(/\./g, METRIC_PATH_SEPARATOR);

export const metricKeyOfSegment = (value) => (value === null || value === undefined ? '' : String(value)).split(METRIC_PATH_SEPARATOR).join('.');

export const ORIGIN_PARAM = 'voltar';

export const ACTIVATION_ORIGIN = 'ativacao';

export const ACTIVATION_KPI_LAG_DAYS = 30;

const ACTIVATION_KPI_RESET = [
  ORIGIN_PARAM, 'saleFrom', 'saleTo', 'salePreset', 'universe', 'status', 'trial', 'started', 'plan', 'journeyNow', 'origin', 'shard',
];

export const CHAT_ORIGIN = 'chat';

export const FEATURE_ORIGIN_PREFIX = 'funcionalidade-';

export const CHAT_PATHS = [PI_BASE_PATH + '/chat', PI_BASE_PATH + '/pergunte'];

const FEATURE_TYPE = /^\d{1,4}$/;

const FEATURE_ORIGIN = /^funcionalidade-(\d{1,4})$/;

const FEATURE_PATH = /^\/product-intelligence\/funcionalidades\/(\d{1,4})\/?$/;

export const featureOrigin = (featureType) => {
  const raw = featureType === null || featureType === undefined ? '' : String(featureType).trim();
  return FEATURE_TYPE.test(raw) ? FEATURE_ORIGIN_PREFIX + Number(raw) : '';
};

export const validOrigin = (value) => {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (raw === ACTIVATION_ORIGIN || raw === CHAT_ORIGIN) return raw;
  const feature = FEATURE_ORIGIN.exec(raw);
  return feature ? featureOrigin(feature[1]) : '';
};

export const originOf = (query) => {
  const raw = query && typeof query === 'object' ? query[ORIGIN_PARAM] : '';
  const value = Array.isArray(raw) ? raw[0] : raw;
  return validOrigin(value);
};

export const originFeatureType = (origin) => {
  const feature = FEATURE_ORIGIN.exec(validOrigin(origin));
  return feature ? Number(feature[1]) : null;
};

export const routeOrigin = (path) => {
  const value = typeof path === 'string' ? path.split('?')[0] : '';
  if (!value) return '';
  if (value === viewPath('activation')) return ACTIVATION_ORIGIN;
  const feature = FEATURE_PATH.exec(value);
  if (feature) return featureOrigin(feature[1]);
  return CHAT_PATHS.indexOf(value.replace(/\/+$/, '')) !== -1 ? CHAT_ORIGIN : '';
};

const chatView = () => PI_VIEWS.filter((view) => view.key === 'assistant' || view.key === 'chat')[0] || null;

const withoutOrigin = (query) => {
  const next = {};
  Object.keys(query && typeof query === 'object' ? query : {}).forEach((key) => {
    if (key !== ORIGIN_PARAM) next[key] = query[key];
  });
  return next;
};

export const companyLink = (companyId, shardCode, query, origin) => {
  const path = companyRoute(companyId, shardCode);
  if (!path) return null;
  const next = withoutOrigin(query);
  const kept = validOrigin(origin);
  if (kept) next[ORIGIN_PARAM] = kept;
  return { path: path, query: next };
};

export const companyBackRoute = (query, origin, featureName) => {
  const from = validOrigin(origin) || originOf(query);
  const next = withoutOrigin(query);
  if (from === ACTIVATION_ORIGIN) return { path: viewPath('activation'), query: next, label: 'Voltar para a ativação', view: 'activation' };
  const featureType = originFeatureType(from);
  if (featureType !== null) {
    const name = typeof featureName === 'string' ? featureName.trim() : '';
    return {
      path: featureRoute(featureType),
      query: next,
      label: name ? 'Voltar para a funcionalidade ' + name : 'Voltar para a funcionalidade',
      view: 'features',
    };
  }
  if (from === CHAT_ORIGIN) {
    const chat = chatView();
    return { path: chat ? chat.path : CHAT_PATHS[0], query: next, label: 'Voltar para o Chat', view: chat ? chat.key : 'companies' };
  }
  return { path: viewPath('companies'), query: next, label: 'Voltar para empresas', view: 'companies' };
};

export const activationCompanyRoute = (query, companyId, companyName) => {
  const next = withoutOrigin(query);
  if (companyId) {
    next.companyId = String(companyId);
    if (companyName) next.companyName = String(companyName);
    else delete next.companyName;
  }
  return { path: viewPath('activation'), query: next };
};

export const accountRoute = (companyId, context) => {
  if (!companyId || !context) return null;
  return '/detalhes-da-empresa/' + segment(companyId) + '/' + segment(context);
};

export const safeInternalRoute = (route) => {
  if (typeof route !== 'string') return null;
  const value = route.trim();
  if (value.charAt(0) !== '/' || value.charAt(1) === '/' || value.charAt(1) === '\\') return null;
  if (/[\s<>"']/.test(value)) return null;
  return value;
};

export const kpiRoute = (kpi) => {
  if (!kpi) return null;
  return safeInternalRoute(kpi.link) || KPI_LINKS[kpi.key] || null;
};

export const activationKpiRoute = (query, period) => {
  const next = {};
  Object.keys(query && typeof query === 'object' ? query : {}).forEach((key) => {
    if (ACTIVATION_KPI_RESET.indexOf(key) === -1) next[key] = query[key];
  });
  const from = period ? addDays(period.from, -ACTIVATION_KPI_LAG_DAYS) : '';
  const to = period ? addDays(period.to, -ACTIVATION_KPI_LAG_DAYS) : '';
  if (from && to) {
    next.saleFrom = from;
    next.saleTo = to;
  }
  return { path: viewPath('activation'), query: next };
};

export const kpiLocation = (kpi, query, period) => {
  const route = kpiRoute(kpi);
  if (!route || kpi.key !== 'activation30d' || route !== viewPath('activation')) return route;
  return activationKpiRoute(query, period);
};

export const readMenuCache = (storage, now, owner, key, keepKnown) => {
  if (!storage) return null;
  try {
    const raw = storage.getItem(key || MENU_CACHE_KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    const at = Number(saved && saved.at);
    const current = typeof now === 'number' ? now : Date.now();
    const kept = keepKnown === true && saved.known === true;
    if (!isFinite(at) || current - at < 0 || (!kept && current - at >= MENU_CACHE_TTL_MS)) return null;
    if ((saved.owner || '') !== (owner || '')) return null;
    return saved.visible === true;
  } catch (e) {
    return null;
  }
};

export const writeMenuCache = (storage, visible, now, owner, key, known) => {
  if (!storage) return;
  try {
    const at = typeof now === 'number' ? now : Date.now();
    const saved = { visible: visible === true, at: at, owner: owner || '' };
    if (known === true) saved.known = true;
    storage.setItem(key || MENU_CACHE_KEY, JSON.stringify(saved));
  } catch (e) {
    return;
  }
};

export const menuVisibleStatus = (status) => status === 200;

export const probeAnswerKnown = (status) => status === 200 || status === 403 || status === 404;

export const probeMenuStatus = (auth, statusOf, exchange) => {
  const source = auth || {};
  if (!source.crossToken) return Promise.resolve(0);
  const fresh = () => exchange(source.crossToken).then((token) => (token ? statusOf(token) : 0));
  if (!source.apiV2Token) return fresh();
  return statusOf(source.apiV2Token).then((status) => (status === 401 ? fresh() : status));
};

export const sessionStore = () => {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piNavigation.js